import React, { useContext, useState } from 'react'
import MetasSemanalesTintoreria from '../../Ventas/ResumenVentas/MetasSemanalesTintoreria'
import CalendarWeek from '../../../Base/Components/Form/CalendarWeek';
import MetasSemanalesPorCategoria from '../../Ventas/ResumenVentas/MetasSemanalesPorCategoria';
import { getLabel } from '../../../Base/Services/Language/LanguageService';
import { baseLang } from '../../../Base/Lang/BaseLang';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DyeingProductionScreen = () => {

  const { config } = useContext(ConfigContext);


  const [fecha, setFecha] = useState(new Date());
  const [showMetasProduccion, setShowMetasProduccion] = useState(false);
  const [getInfo, setGetInfo] = useState(false);

  let Mes = fecha.toLocaleString('es-ES', { month: 'long' })
  const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);


  return (
    <div>
      <div className='mx-4 mt-2'>
        <CalendarWeek date={fecha} setDate={e => setFecha(e)}
          // buscar={buscar}
          view="month" dateFormat="mm/yy"
        />

      </div>

      <div>
        <MetasSemanalesPorCategoria kpiGerencia={false} date={fecha} getDatos={getInfo} altura={true} />

        <MetasSemanalesTintoreria
          kpiGerencia={true}
          date={fecha}
          // getDatos={getInfo}
          setShowMetasProduccion={setShowMetasProduccion}
        />

      </div>


      <Dialog
        visible={showMetasProduccion}
        onHide={() => { setShowMetasProduccion(false) }}
        // header={<h4>{`Producción Mensual (${monthName} / ${fecha.getFullYear()}) (Kg)`}</h4>}
        header={<h4>{`${getLabel(baseLang, "pMensual", config.language)} (${monthName} / ${fecha.getFullYear()}) (Kg)`}</h4>}
        maximized={false}
        closeOnEscape={false}
        style={{ width: '80vw' }}
        resizable={false}
      >
        {/* <div style={ {width: '100%', overflow: 'hidden', height: '50%'}}> */}
        <MetasSemanalesPorCategoria kpiGerencia={false} date={fecha} getDatos={getInfo} altura={true} />
        {/* </div> */}
      </Dialog>
    </div>
  )
}

export default DyeingProductionScreen